<div class="dialog-container">
  <div class="dialog-header">
    <oph-back-button (buttonClick)="onClose()" />
    @if (chartDetailLoading()) {
      <mat-spinner class="dialog-header-spinner" diameter="24" aria-hidden="true" />
    }
  </div>

  <div class="dialog-content">
    @if (chartDetail(); as detail) {
      <div class="chart-detail-card">
        <cs-chart-detail-dialog-header
          [icon]="detail.taskIcon"
          [name]="detail.name"
          [percentComplete]="percentComplete()"
          [currentValueDisplay]="
            detail.type === 'boolean' ? '' : '' + (detail.currentValue | trackerMetricValue: detail.type)
          "
          [targetValueDisplay]="
            detail.type === 'boolean'
              ? ''
              : '' + (detail.targetValue | trackerMetricValue: detail.type) + (detail | challengeMetricUomDisplay)
          "
          [progressColor]="getChartProgressColor(detail.name)"
        />

        <div class="log-section">
          @if (detail.logEntries?.length) {
            <div class="log-section-header">
              <span class="log-section-title">Recent</span>
              <span class="log-section-total"
                >{{
                  detail.type === 'boolean'
                    ? detail.currentValue
                    : (detail.currentValue | trackerMetricValue: detail.type)
                }}{{ detail | challengeMetricUomDisplay }}</span
              >
            </div>
            <div class="log-list">
              @for (entry of detail.logEntries; track entry.exactLoggedAt) {
                <div class="log-entry">
                  <div class="log-entry-date">{{ entry.exactLoggedAt | moment: 'ddd, MMM D' }}</div>
                  <div class="log-entry-time">{{ entry.exactLoggedAt | moment: 'h:mm a' }}</div>
                  <div class="log-entry-value">
                    {{ entry.value | trackerMetricValue: detail.type
                    }}{{ detail.type === 'boolean' ? '' : (detail | challengeMetricUomDisplay) }}
                  </div>
                </div>
              }
            </div>
          } @else {
            <p class="log-section-empty">No entries yet. Log progress to see your history here.</p>
          }
        </div>
      </div>
    } @else {
      <div class="dialog-loading">Loading…</div>
    }
  </div>
</div>
